export class ReceiptLayout {
  id: number
  code: string
  description: string
  blockLines: Block[]

  constructor(props: ReceiptLayout) {
    Object.assign(this, props)
  }
}

class Block {

}

export class BlockText extends Block {
  fontSize: FontSize
  align: AlignType
  text: string

  constructor(props: object) {
    super()
    Object.assign(this, props)
  }

}

export class Separator extends Block {
  pattern: string

  constructor(value: string) {
    super()
    if (value.length > 1) {
      throw new Error('value no is character')
    }
  }
}

export enum AlignType {
  Left = 'left',
  Center = 'center',
  Right = 'right'
}

export enum FontSize {
  Small = 'small normal',
  Big = 'big'
}
export enum FontAtt {
  Normal = 'normal',
  Bold = 'bold',
  Cursiva = 'cursiva'
}

export enum Placeholders {
  firstName = '${firstName}',
  lastName = '${lastName}',
  staffId = '${staffId}',
  date = '${date}',
  time = '${time}',
  waypoint = '${waypoint}',
  validUntil = '${validUntil}',
  validFor = '${validFor}',
  eventDate = '${eventDate}',
  eventTime = '${eventTime}',
  account = '${account}',
  ticketNumber = '${ticketNumber}',
  receiptNumber = '${receiptNumber}',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/ReceiptLayouts/Model.ts